import React from 'react';
import PropTypes from 'prop-types';
import './OnboardingStepWizard.css';

export const OnboardingStepWizard = ({
  currentOnboardingStep,
  currentOnboardingSteps,
  handleGoToAnswer,
}) => {
  const ordinals = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'];
  const enabledSteps = currentOnboardingSteps.filter(
    s => !s.disabled && s.key !== 'animation',
  );
  const done = enabledSteps.filter(
    s => s.status === 'done' && s.key !== 'animation',
  ).length;
  const all = enabledSteps.length;
  const progress = 100 * (done / all);

  const getStatus = elem => {
    if (elem.key === currentOnboardingStep) {
      return 'current';
    }
    if (elem.status === 'done') {
      return elem.status;
    }
    return 'empty';
  };

  const getFirstStep = (elem, index, status, isClickable) => (
    <div
      onClick={isClickable ? () => handleGoToAnswer(elem.key) : () => null}
      className={`col-3 col-md-2 col-lg d-flex align-items-lg-center justify-content-lg-center flex-column flex-lg-row py-4 steps-progress__item-first steps-progress__item-first--${status}
      ${isClickable ? 'steps-progress--clickable' : ''}`}
      key={elem.key}
    >
      <div
        className={`step-wizard-bar-circle step-wizard-bar-circle-${status} mx-auto mx-lg-0 mr-lg-4 d-flex align-items-center justify-content-center`}
      >
        {index + 1}
      </div>
      <div className="step-wizard-bar-labels d-none d-md-block mt-2 t-lg-0 text-center text-lg-left">
        <p className="t-9 text-uppercase step-wizard-bar-title font-weight-bold mb-2">
          {ordinals[index]} step
        </p>
        <p className="t-13">{elem.name}</p>
      </div>
    </div>
  );

  const getFirstFilledStep = (elem, index, status, isClickable) => (
    <div
      onClick={isClickable ? () => handleGoToAnswer(elem.key) : () => null}
      className={`col-3 col-md-2 col-lg d-flex align-items-lg-center justify-content-lg-center flex-column flex-lg-row py-4 steps-progress__item-first-next-filled steps-progress__item-first-next-filled--${status} ${
        isClickable ? 'steps-progress--clickable' : ''
      }`}
      key={elem.key}
    >
      <div
        className={`step-wizard-bar-circle step-wizard-bar-circle-${status} mx-auto mx-lg-0 mr-lg-4 d-flex align-items-center justify-content-center`}
      >
        {index + 1}
      </div>
      <div className="step-wizard-bar-labels d-none d-md-block mt-2 t-lg-0 text-center text-lg-left">
        <p className="t-9 text-uppercase step-wizard-bar-title font-weight-bold mb-2">
          {ordinals[index]} step
        </p>
        <p className="t-13">{elem.name}</p>
      </div>
    </div>
  );

  const getLastStep = (elem, index, status, isClickable) => (
    <div
      onClick={isClickable ? () => handleGoToAnswer(elem.key) : () => null}
      className={`col-3 col-md-2 col-lg d-flex align-items-lg-center justify-content-lg-center flex-column flex-lg-row py-4 steps-progress__item-last steps-progress__item-last--${status} ${
        isClickable ? 'steps-progress--clickable' : ''
      } `}
      key={index}
    >
      <div
        className={`step-wizard-bar-circle step-wizard-bar-circle-${status} mx-auto mx-lg-0 mr-lg-4 d-flex align-items-center justify-content-center`}
      >
        {index + 1}
      </div>
      <div className="step-wizard-bar-labels d-none d-md-block mt-2 t-lg-0 text-center text-lg-left">
        <p className="t-9 text-uppercase step-wizard-bar-title font-weight-bold mb-2">
          {ordinals[index]} step
        </p>
        <p className="t-13">{elem.name}</p>
      </div>
    </div>
  );

  const getNotFilledStep = (elem, index, status, isClickable) => (
    <div
      onClick={isClickable ? () => handleGoToAnswer(elem.key) : () => null}
      className={`col-3 col-md-2 col-lg d-flex align-items-lg-center justify-content-lg-center flex-column flex-lg-row py-4 steps-progress__item steps-progress__item--next-not-filled ${
        isClickable ? 'steps-progress--clickable' : ''
      }`}
      key={elem.key}
    >
      <div
        className={`step-wizard-bar-circle step-wizard-bar-circle-${status} mx-auto mx-lg-0 mr-lg-4 d-flex align-items-center justify-content-center`}
      >
        {index + 1}
      </div>
      <div className="step-wizard-bar-labels d-none d-md-block mt-2 t-lg-0 text-center text-lg-left">
        <p className="t-9 text-uppercase step-wizard-bar-title font-weight-bold mb-2">
          {ordinals[index]} step
        </p>
        <p className="t-13">{elem.name}</p>
      </div>
    </div>
  );

  const getStep = (elem, index, status, isClickable) => (
    <div
      onClick={isClickable ? () => handleGoToAnswer(elem.key) : () => null}
      className={`col-3 col-md-2 col-lg d-flex align-items-lg-center justify-content-lg-center flex-column flex-lg-row py-4 steps-progress__item steps-progress__item--${
        currentOnboardingSteps[index + 1].status === 'done' &&
        status === 'current'
          ? 'special'
          : status
      } ${isClickable ? 'steps-progress--clickable' : ''}`}
      key={elem.key}
    >
      <div
        className={`step-wizard-bar-circle step-wizard-bar-circle-${status} mx-auto mx-lg-0 mr-lg-4 d-flex align-items-center justify-content-center`}
      >
        {index + 1}
      </div>
      <div className="step-wizard-bar-labels d-none d-md-block mt-2 t-lg-0 text-center text-lg-left">
        <p className="t-9 text-uppercase step-wizard-bar-title font-weight-bold mb-2">
          {ordinals[index]} step
        </p>
        <p className="t-13">{elem.name}</p>
      </div>
    </div>
  );

  return (
    <div className="container-fluid step-wizard-bar shadow-mid">
      <div className="step-wizard-bar-bg row">
        <div
          className="step-wizard-bar-progress"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="row justify-content-center d-none">
        {currentOnboardingSteps &&
          currentOnboardingSteps
            .filter(item => item.disabled !== true)
            .map((elem, index) => {
              const status = getStatus(elem);
              const isClickable = elem.selectedValue.length > 0;

              const isFirstStep = () =>
                index === 0 &&
                currentOnboardingSteps[index + 1].status === 'empty';
              const isFirstFilledStep = () =>
                index === 0 &&
                currentOnboardingSteps[index + 1].status !== 'empty';
              const isLastStep = () =>
                index === currentOnboardingSteps.length - 1;
              const isNotFilledStep = () =>
                currentOnboardingSteps[index + 1].status === 'empty' &&
                currentOnboardingSteps[index + 1].key !==
                  currentOnboardingStep &&
                status === 'done';

              if (isFirstStep()) {
                return getFirstStep(elem, index, status, isClickable);
              }
              if (isFirstFilledStep()) {
                return getFirstFilledStep(elem, index, status, isClickable);
              }
              if (isLastStep()) {
                return getLastStep(elem, index, status, isClickable);
              }
              if (isNotFilledStep()) {
                return getNotFilledStep(elem, index, status, isClickable);
              }
              return getStep(elem, index, status, isClickable);
            })}
      </div>
    </div>
  );
};

OnboardingStepWizard.propTypes = {
  currentOnboardingStep: PropTypes.string,
  currentOnboardingSteps: PropTypes.array,
  handleGoToAnswer: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/OnboardingStepWizard/OnboardingStepWizard.js